import { render, staticRenderFns } from "./material-printer.vue?vue&type=template&id=2465fb57&"
import script from "./material-printer.vue?vue&type=script&lang=js&"
export * from "./material-printer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2465fb57')) {
      api.createRecord('2465fb57', component.options)
    } else {
      api.reload('2465fb57', component.options)
    }
    module.hot.accept("./material-printer.vue?vue&type=template&id=2465fb57&", function () {
      api.rerender('2465fb57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Inshape/Admin/Materials/AddMaterial/PrinterComponent/material-printer.vue"
export default component.exports